/**
 * Readonly display for the overall evaluation (rating) field.
 * Renders the same pill/badge style as InterviewScorecardReadonly when
 * the field is not editable and has a value.
 */

import { Flex, Icon } from '@chakra-ui/react';
import { KText } from '@/ui-library/components';
import { getSelectionRatingStyle } from '@/constants/scorecard-configs';

export const RatingReadonlyPill = ({ value, options = [] }) => {
  const ratingConfig = options.find((opt) => opt?.value === value);
  const scorecardStyles = getSelectionRatingStyle(ratingConfig);

  if (!value || !ratingConfig) {
    return (
      <KText size="sm-medium" color="secondary-700">
        -
      </KText>
    );
  }

  return (
    <Flex
      gap="6px"
      alignItems="center"
      borderRadius="4px"
      bg={ratingConfig?.bgColor}
      p="0.125em 0.5em"
      w="fit-content"
    >
      <Icon
        as={ratingConfig?.icon}
        w="24px"
        h="24px"
        color={ratingConfig?.selectedColor}
        {...scorecardStyles}
      />
      <KText size="sm-medium" color={ratingConfig?.selectedColor}>
        {ratingConfig?.label}
      </KText>
    </Flex>
  );
};
